import { isIdentificationDocument } from '@helpers/validator';

const schema = {
  rut: {
    type: 'text',
    errorMessage: ['errors.rut.required', 'errors.rut.invalid'],
    isValid: [(value) => value.length > 0, (value) => isIdentificationDocument(value)],
  },
};

export default schema;
